import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgSettlementIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M21 5.571H5a2 2 0 0 0-2 2V12m18-6.429-2.5 2.572M21 5.57 18.5 3M3 18.429h16a2 2 0 0 0 2-2V12M3 18.429l2.5-2.572M3 18.43 5.5 21"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgSettlementIcon);
const Memo = memo(ForwardRef);
export default Memo;
